'use strict';

const Mn = require('backbone.marionette');
const ElementAction = require('system/domain/action/element');
const ElementService = require('system/domain/service/element');
const Template = require('system/ui/template/modal/node-delete.hbs');

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        deleteMetaButton: '.delete-meta-only',
        deleteButton: '.delete',
        cancelButton: '.cancel'
    },
    events: {
        'click @ui.deleteMetaButton': 'deleteMeta',
        'click @ui.deleteButton': 'delete',
        'click @ui.cancelButton': 'cancel'
    },

    initialize: function(params) {
        this._context = params.context;
    },

    serializeData: function() {
        return {
            isMultiple: ElementService.getProjectedDiagrams({
                context: this._context,
                model: this.model
            }).length > 0
        };
    },

    show: function() {
        this.$('.modal').modal('show');
    },

    deleteMeta: function() {
        ElementAction.deleteSymbolicNode({
            context: this._context,
            node: {id: this.model.id}
        });
        this.$('.modal').modal('hide');
    },

    delete: function() {
        ElementAction.deleteNode({
            context: this._context,
            node: {id: this.model.id}
        });
        this.$('.modal').modal('hide');
    },

    cancel: function() {
        this.$('.modal').modal('hide');
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/modal/node-delete.js